<template>
  <v-container>

    <v-row justify="space-around">
      <v-avatar size="100">
        <img
          :src="require('../assets/profile-placeholder.svg')"
          alt=""
          v-if="mode === 'create' || !user.profile_picture"
        >
        <img
          :src="user.profile_picture"
          lazy-src="user.profile_picture"
          v-else
        >
      </v-avatar>
    </v-row>

    <v-row justify="center">
      <v-col cols="12" md="4" class="text-center">
        <div @click="$refs.fileInput.$el.querySelector('input').click()" class="text-h6 primary--text" style="cursor: pointer;">
          <p style="font-size: small; color: black;">{{ $t('fields.user.change_image') }}</p>
        </div>
        <v-file-input
          ref="fileInput"
          v-model="image"
          style="display: none;"
          accept="image/png, image/jpeg, image/bmp"
          @change="updateImage"
        >
        </v-file-input>
      </v-col>
    </v-row>

    <ValidationObserver ref="userForm" v-slot="{ valid }">
      <v-form v-model="valid">
        <v-container>
          <div>
            <v-row
              align="center">
              <div class="mx-1 field-custom ml-3">{{ $t('fields.user.name') }}</div>
            </v-row>
            <ValidationProvider vid="name" rules="required|max:255" v-slot="{ errors, valid }" name="name">
              <v-text-field
                counter="255"
                name="name"
                :placeholder="$t('fields.user.name')"
                type="text"
                v-model="user.name"
                :error-messages="errors"
                :success="valid"
                disabled
                outlined
                dense
                class="custom-textfield"
              ></v-text-field>
            </ValidationProvider>
          </div>
          <div>
            <v-row
              align="center">

              <div class="mx-1 field-custom ml-3">{{ $t('fields.user.email') }}</div>
            </v-row>
            <ValidationProvider vid="email" rules="required|email" v-slot="{ errors, valid }" name="email">
              <v-text-field
                name="email"
                type="text"
                :placeholder="$t('fields.user.email')"
                v-model="user.email"
                :error-messages="errors"
                :success="valid"
                disabled
                outlined
                class="custom-textfield"
                dense
              ></v-text-field>
            </ValidationProvider>
          </div>
          <div>
            <div>
              <v-row
                align="center">
                <div class="mx-1 field-custom ml-3">{{ $t('fields.user.password') }}</div>
              </v-row>
              <ValidationProvider vid="password" rules="required|min:8|confirmed:password_confirmation"
                                  v-slot="{ errors, valid }" name="password">
                <v-text-field
                  :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="show1 ? 'text' : 'password'"
                  name="password"
                  @click:append="show1 = !show1"
                  v-model="user.password"
                  :error-messages="errors"
                  :success="valid"
                  outlined
                  class="custom-textfield"
                  dense
                ></v-text-field>
              </ValidationProvider>
            </div>
          </div>
          <div>
            <div>
              <v-row
                align="center">

                <div class="mx-1 field-custom ml-3">{{ $t('fields.user.confirm_password') }}</div>
              </v-row>
              <ValidationProvider vid="password_confirmation" rules="required" v-slot="{ errors, valid }"
                                  name="confirm password">
                <v-text-field
                  :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="show2 ? 'text' : 'password'"
                  name="password_confirmation"
                  @click:append="show2 = !show2"
                  v-model="user.password_confirmation"
                  :error-messages="errors"
                  :success="valid"
                  outlined
                  class="custom-textfield"
                  dense
                ></v-text-field>
              </ValidationProvider>
            </div>
          </div>
        </v-container>
        <v-container>
          <v-row justify="space-between" class="px-3 button-row">
              <v-btn  :disabled="load"  @click="close" class="border-btn style-btn"  outlined color="#EDE939" dark><span style="color: black;">{{ $t('buttons.cancel') }}</span></v-btn>

              <v-btn
                :disabled="!valid"
                @click="onCreate"
                color="#EDE939"
                v-if="mode === 'create'"
                :loading="load"
                class="style-btn"
              >
                {{ $t('buttons.add') }}
              </v-btn>

              <v-btn
                :disabled="!valid"
                @click="onSave"
                color="#EDE939"

                v-else
                :loading="load"
                class="style-btn"
              >
                {{ $t('buttons.save') }}
              </v-btn>

          </v-row>
        </v-container>
      </v-form>
    </ValidationObserver>
  </v-container>
</template>

<script>
import FormErrors from '@/mixins/FormErrors'
import Swal from 'sweetalert2'
import _ from 'lodash'

export default {
  name: 'NewUserForm',
  mixins: [FormErrors],
  props: {
    mode: {
      type: String,
      enum: ['update', 'create']
    },
    user: {
      type: Object,
      required: true
    },
    onSave: {
      type: Function,
      required: true
    },
    close: {
      type: Function,
      required: true
    },
    load: {
      type: Boolean,
      required: true
    },
    status: {}
  },
  async mounted () {

  },
  data () {
    return {
      rolesSelected: {},
      show1: false,
      show2: true,
      image: null
    }
  },
  created () {
    this.rolesSelected.roles = this.user.roles_names
  },
  methods: {
    async updateImage () {
      try {
        const formData = new FormData()
        formData.append('profile_picture', this.image)

        const response = await this.$http.post(`${process.env.VUE_APP_API_URL}/clients/${this.userLogged.client_id}/users/${this.userLogged.id}/profile-picture`, formData)
        const image = response.data.profile_picture
        this.$store.dispatch('updateImage', image)
          .then(() => {
            this.close()
            Swal.fire(
              '¡Actualizado!',
              '!La imagen del usuario ha sido actualizada con éxito¡',
              'success'
            )
            this.$nextTick(() => {
              window.location.reload()
            })
          })
      } catch (e) {
        Swal.fire(
          this.$t('headers.error'),
          _.get(e, 'response.data.message', this.$t('titles.serverError')),
          'error'
        )
      }
    }
  },
  computed: {
    userLogged () {
      return this.$store.getters.userLogged
    }
  }
}
</script>

<style>

.field-custom {
  font-size: 14px;
  color: black;
}

.style-btn {
  max-width: 128px !important;
  width: 100%;
}

@media (max-width: 410px) {
  .button-row {
    flex-direction: column !important;
    align-items: center !important;
  }

  .button-row .v-btn {
    margin: 5px 0 !important;
    width: 100%;
    max-width: 300px;
  }
}

</style>
